import { Accessor, ColorX, ZValidate } from "IZOX/STATIC";
import { HStack, XIconButton } from "IZOX/_X";
// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from "react";
import { GoEye, GoEyeClosed } from "react-icons/go";
import QFText from "./QFText";
import _ from "lodash";

/**
 * @typedef {import("IZOX/_X/XInput").xinputparams} xinputparams
 * @typedef {import("IZOX/_X/XInput").xinputstyleparams} xinputstyleparams
 * @typedef {import("./QFText").qftextparams} qftextparams
 * @typedef {import("IZOX/STATIC/ZValidate").fvalidate} fvalidate
 * 
 * @typedef {qftextparams & xinputparams & xinputstyleparams} qfpasswordparams
 * 
 * @param {qfpasswordparams} param0
 * @returns 
 */
function QFPassword({
  name = undefined,
  label = undefined,
  _onSetDefault = null,
  defaultValue = undefined,
  updateVia = undefined, 
  updateField = undefined,
  forceUpdateField = undefined,
  performanceBoost = undefined,
  isError = undefined,
  addOns = undefined,
  formValue = {},
  error_color = ColorX.CSS("Error"),
  validators = [],
  ...others
}){

  useEffect(() => {
    if(defaultValue) {
      _onSetDefault?.(name, defaultValue);
      setValue(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);

  const [value, setValue] = useState();

  useEffect(() => {
    let _value = Accessor.Get(formValue, name);
    setValue(_value);
  }, [formValue, name]);

  const [showPassword, setShowPassword] = useState(false);

  const toggleShow = () => {
    setShowPassword(!showPassword);
  };

  let _error = false;
  if(isError){
    _error = _error || isError({doc: formValue, field: value, addOns});
  }
  if(!_.isEmpty(validators)){
    _error = _error || !ZValidate.Check(value, validators);
  }

  let {bgColor, bW, bColor, fontSize} = others;
  return (
    <HStack bgColor={bgColor ?? ColorX.CSS("pureWhite")} bW={bW} 
      bColor={_error? error_color : bColor}>
      <QFText
        type={showPassword? "text" : "password"}
        fontSize={fontSize}
        isError={isError}
        name={name}
        formValue={formValue}
        _onSetDefault={_onSetDefault}
        defaultValue={defaultValue}
        addOns={addOns}
        {...others}
        bW={0}
        />
      <XIconButton onPress={toggleShow}>
        {showPassword?
        <GoEye color={ColorX.CSS("greyOut")} size={fontSize + 5}/> : 
        <GoEyeClosed color={ColorX.CSS("greyOut")} size={fontSize + 5}/>}
      </XIconButton>
    </HStack>
  );
}

export default QFPassword;
